export const buttonsRow1 = [
  {indexNumber: 0, color: 'red'},
  {indexNumber: 1, color: 'green'}
];

export const buttonsRow2 = [
  {indexNumber: 2, color: 'yellow'},
  {indexNumber: 3, color: 'aqua'}
];